import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFedrampComponent } from './simple-icons-fedramp.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFedrampComponent ],
    exports:      [ SimpleIconsFedrampComponent ],
    bootstrap:    []
})
export class SimpleIconsFedrampModule {}
